export enum KitType {
  HOME = 'home',
  AWAY = 'away',
  THIRD = 'third',
  GOALKEEPER = 'goalkeeper',
}
